<template>
  <div id="index" @keydown="keydown()">
    <el-container>
      <el-main>
         <img
              v-if="brand == 'IR'"
              src="~assets/img/splash_logo.png"
               style="
            width: 475px;
            height: 203px;
            position: absolute;
            top: 150px;
            left: 124px;
          "
            />
            <img
              v-if="brand == 'GD'"
              src="~assets/img/GDlogo.png"
               style="
            width: 300px;
            height: 110px;
            position: absolute;
            top: 150px;
            left: 100px;
          "
            />
        <!-- <img
          src="~assets/img/splash_logo.png"
          style="
            width: 475px;
            height: 203px;
            position: absolute;
            top: 150px;
            left: 124px;
          "
        /> -->

        <el-button
          style="position: absolute; top: 400px; left: 124px"
          @click="skip()"
          >Skip ({{ skipSecond }}s)
          <i
            class="el-icon-arrow-right el-icon--right"
            style="vertical-align: text-bottom; font-weight: bold"
          ></i
        ></el-button>
        <!-- <div class="loginRecordBox">
          <el-link href="https://www.irconnectivity.com" target="_blank"
            >备案主体：英格索兰（中国）投资有限公司</el-link
          >
          <el-link href="https://www.beian.miit.gov.cn" target="_blank"
            >备案号：沪ICP备05062828号-5</el-link
          >
          <el-link
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502005741"
            target="_blank"
            ><img
              src="~assets/img/recordicon.png"
              style="float: left; width: 16px"
            />沪公网安备 31010502005741号
          </el-link>
        </div> -->
      </el-main>
    </el-container>
  </div>
</template>

<script type="text/javascript">
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import router from "../../../src/router/index";
import {
  setItemToLocalstorage,
  getItemFormLocalstorage,
} from "../../../utils/package-localstorage";
export default {
  name: "Index",
  data() {
    return {
      skipSecond: 10,
      menuList: [],
      skipUrl: "",
        brand: "",
    };
  },
  computed: {
    ...mapGetters({
      activeLang: "language",
      menuListStore: "menuListState",
      authOperationStore: "authOperationState",
    }),
  },
  created: function () {
       this.brand = Globals.VUE_APP_Brand;
    var self = this;
    if (
      this.menuListStore != null &&
      this.menuListStore != undefined &&
      this.menuListStore.length > 0
    )
      this.menuList = this.menuListStore;
    else {
      this.menuList = getItemFormLocalstorage("menuData");
    }
    var isHasDefault=false;
    this.menuList.forEach(function (obj) {
      if (obj.url == "/index") isHasDefault = true;
    });
    if (isHasDefault) {
      self.skipUrl = "/index";
    } else {
      this.menuList.forEach(function (obj, index) {
        if (index == 0) {
          if (obj.children.length > 0) {
            obj.children.forEach(function (o, i) {
              if (i == 0) self.skipUrl = o.url;
            });
          }
        }
      });
    };
    setInterval(function () {
      var i = self.skipSecond;
      if (i > 0) self.skipSecond = i - 1;
    }, 1000);
    setTimeout(function () {
      window.location.href = self.skipUrl;
    }, 10000);
  },
  methods: {
    skip() {
      window.location.href = this.skipUrl;
    },
  },
};
</script>

 
<style lang='less'>
.theme1 {
  .el-main {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url("~assets/img/splash.jpg");
    background-position: left top;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .el-main {
    padding: 20px 7%;
    width: 100%;
  }
}
</style>
